import type { Component } from "solid-js";
import { useTranslation } from "../../../state/i18n";
import { useNavigate } from "@solidjs/router";
import { isEmpty } from "lodash-es";
import { useCustomerState } from "../../../state/customer";
import ApiService from "../../../services/ApiService";
import { IconButton } from "../../../components/button/Button";
import { DestructiveModal, InformativeModal } from "../../../components/modal/Modal";
import type { Folder } from "../../../types/Folder";
import GenericFailureModal from "../../GenericFailureModal";
import { useModalManager } from "../../../components/modal/ModalManager";

const DeleteFolderButton: Component<{ folder: Folder }> = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { open, replace } = useModalManager();
  const customer = useCustomerState();

  return (
    <IconButton
      icon="trash"
      aria-label={t(($) => $.DELETE_ARIA)}
      variant="secondary"
      onClick={() => {
        if (isEmpty(props.folder.forms.filter((form) => form.status === "ACTIVE"))) {
          open({
            content: () => (
              <DestructiveModal
                confirmLabel={t(($) => $.DELETE_FOLDER_CONFIRMATION_MODAL_ACTIONS_CONFIRM)}
                confirmLabelSlow={t(($) => $.DELETE_FOLDER_CONFIRMATION_MODAL_ACTIONS_CONFIRM_SLOW)}
                cancelLabel={t(($) => $.DELETE_FOLDER_CONFIRMATION_MODAL_ACTIONS_CANCEL)}
                title={t(($) => $.DELETE_FOLDER_CONFIRMATION_MODAL_TITLE)}
                description={t(($) => $.DELETE_FOLDER_CONFIRMATION_MODAL_DESCRIPTION)}
                onConfirm={() => {
                  const folderId = props.folder.id;
                  return new Promise<void>((resolve, reject) =>
                    ApiService.deleteFolder().mutate(folderId, {
                      onSuccess: () => {
                        navigate(`/customers/${customer.customerId}`); // DEV-6974 Redirect to next folder in the list
                        resolve();
                      },
                      onError: (err) => {
                        replace({
                          content: () => (
                            <GenericFailureModal title={t(($) => $.DELETE_FOLDER_FAILURE_MODAL_TITLE)} error={err} />
                          ),
                        });
                        reject(err);
                      },
                    }),
                  );
                }}
              />
            ),
          });
        } else {
          open({
            content: () => (
              <InformativeModal
                confirmLabel={t(($) => $.DELETE_FOLDER_NOT_EMPTY_MODAL_ACTIONS_CLOSE)}
                closeAriaLabel={t(($) => $.CLOSE_ARIA)}
                title={t(($) => $.DELETE_FOLDER_NOT_EMPTY_MODAL_TITLE)}
                description={t(($) => $.DELETE_FOLDER_NOT_EMPTY_MODAL_DESCRIPTION)}
              />
            ),
          });
        }
      }}
    />
  );
};

export default DeleteFolderButton;
